import { getGuests } from '@bridebook/web/lib/guestlist/selectors';
import { useRecipientsContext } from '@bridebook/web/lib/inbox/guests/create-message-flow/recipients/recipients-context';
import { useDispatch, useSelector } from '@bridebook/web/lib/utils';
import { useMemo } from 'react';
import { UpdateEmailModal } from '@bridebook/web/components/guestlist/update-email';
import { interactedWithGuestCommsAction } from '@bridebook/web/lib/inbox/guests/analytics/actions';

export const UpdateRecipientEmailModal = () => {
  const dispatch = useDispatch();
  const { guestIdForEmailEdit, setGuestIdForEmailEdit } = useRecipientsContext();

  const guests = useSelector(getGuests);

  const guest = useMemo(
    () => guests.find((guest) => guest.id === guestIdForEmailEdit),
    [guests, guestIdForEmailEdit],
  );

  if (!guest) return null;

  const handleEmailUpdated = () => {
    dispatch(
      interactedWithGuestCommsAction({
        action: 'clicked',
        location: 'guestComms',
        section: 'selectRecipients',
        element: 'missingEmailHyperlink',
        elementLabel: 'Save and continue',
      }),
    );
  };

  return (
    <UpdateEmailModal
      isOpen={!!guestIdForEmailEdit}
      onClose={() => setGuestIdForEmailEdit(null)}
      guest={guest}
      onEmailUpdated={handleEmailUpdated}
    />
  );
};
